import React, {Component} from 'react';
import cookie from "react-cookies";
import {AreaChartOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, Col, Input, message, Modal, Row, Table, Tooltip, Typography,} from 'antd';
import {connect} from "react-redux";
import '../asset/style/custom_antd_table_style.css';

import querystring from "query-string";
import {openEndPoint} from "../utils/utils";
import {post} from "../helper/request";
import {aclPermissions, hasPermissions} from "../const/ACLPermissions";

const {Title} = Typography;
const {TextArea} = Input;

class validationStudies extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            addValidationStudy: false,
            validationIdList: [],
            newValidation: '',
            validation_check_flag: false,
            description: '',
            validationIds: [],
        }
        this.is_clia_staff = hasPermissions([aclPermissions.clia_staff])
        this.Staffcolumns = [
            {
                title: 'VALIDATION STUDY NAME',
                width: '20%',
                dataIndex: 'obj',
                render: obj => <a style={{color: 'darkblue'}} href={`clia_validation/${obj.id}`}>{obj.name}</a>,
            }, {
                title: 'DESCRIPTION',
                width: '60%',
                dataIndex: 'description'
            }
            , {
                title: 'CASE COUNT',
                width: '10%',
                dataIndex: 'count'
            }, {
                title: 'SUMMARY',
                width: '10%',
                dataIndex: 'summary',
                render: (text, record) => {
                    return <div>
                        <Tooltip title="View Summary" placement="right">
                            <AreaChartOutlined
                                onClick={() => this.openSummary(record.obj.id, record.obj.name)}
                                style={{fontSize: '40px'}}
                            />
                        </Tooltip>
                    </div>
                }
            }
        ]

        this.nonStaffColumns = [
            {
                title: 'VALIDATION STUDY NAME',
                width: '20%',
                dataIndex: 'obj',
                render: obj => <a style={{color: 'darkblue'}} href={`clia_validation/${obj.id}`}>{obj.name}</a>,
            }, {
                title: 'DESCRIPTION',
                width: '60%',
                dataIndex: 'description'
            }
            , {
                title: 'CASE COUNT',
                width: '10%',
                dataIndex: 'count'
            }
        ]
    }

    componentWillMount() {
        this.getValidationIDs();
        let url = `/api/get_all_validation_id/`;
        post(url, querystring.stringify({user: parseInt(cookie.load('user_id'))}))
            .then(data_resp => {
                let data = data_resp['data']
                let ids = []
                for (let i = 0; i < data.length; i++) {
                    ids.push(data[i].id)
                }
                this.setState({validationIds: ids})
            })
    }


    getValidationIDs = () => {
        let url = `/api/get_all_validation_id/`;
        post(url, querystring.stringify({user: parseInt(cookie.load('user_id'))}))
            .then(data => {
                this.setState({
                    data: data['data'],
                })
            })
    }

    openAddNewValidationStudy = () => {
        this.setState({
            addValidationStudy: true,
        })
    }

    openSummary = (id, name) => {
        openEndPoint("/summary/" + id, false, true);
    }

    handleCancel = () => {
        this.setState({
            addValidationStudy: false,
        })
    }

    createValidation = (e) => {
        let url = `/api/create_validation/`;
        let validationId = this.state.newValidation
        let validationIds = this.state.validationIds
        for (let i = 0; i < validationIds.length; i++) {
            if (validationIds[i] === validationId) {
                message.info("Validation Id already exists", 3);
                return;
            }
        }
        let description = this.state.description
        post(url, querystring.stringify({
            id: validationId,
            user: parseInt(cookie.load('user_id')),
            description: description
        })).then(res => {
            this.setState({newValidation: ''})
            window.location.reload();
        })
    }

    changeValidationName = (e) => {
        let index = this.state.validationIdList.findIndex((item) => e.target.value.toLowerCase() === item.toLowerCase());
        if (index === -1) {
            this.setState({
                newValidation: e.target.value,
                validation_check_flag: false
            });
        } else {
            this.setState({
                newValidation: e.target.value,
                validation_check_flag: false
            })
        }
    }

    changeDescription = (e) => {
        this.setState({
            description: e.target.value,
        })
    }

    render() {
        return (
            <div className={"full-parent all-slides"}>
                <Row>
                    <Title> CLIA VALIDATIONS </Title>
                </Row>
                {this.is_clia_staff && <Row>
                    <Col span={3}>
                        <Button onClick={this.openAddNewValidationStudy}>
                            Add Validation Study
                            <PlusOutlined style={{fontSize: "13px"}}/>
                        </Button>
                    </Col>
                    <br></br>
                </Row>}
                <br/>
                <Row>
                    <Table
                        className="custom-hover-table-case custom-table-height custom-table-selection custom-table-header"
                        rowClassName={(record, index) => (record.unread ? 'slide-table-rows custom-hover-table-box unread' : 'slide-table-rows custom-hover-table-box read')}
                        bordered
                        columns={this.is_clia_staff ? this.Staffcolumns : this.nonStaffColumns}
                        dataSource={this.state.data}
                        size="small"
                    >
                        <Row>{"study 1"}</Row>
                    </Table>
                </Row>
                <Modal
                    visible={this.state.addValidationStudy}
                    title="ADD VALIDATION STUDY"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>
                            Cancel
                        </Button>,
                        <Button key="submit"
                                onClick={this.createValidation}
                                disabled={!(!this.state.validation_check_flag && this.state.newValidation.length > 0)}
                                type='primary'
                        >
                            Submit
                        </Button>,
                    ]}
                >
                    <Row>
                        <Col>
                            <div>
                                <Row className="add-case-row">
                                    <Col span={5} className="add-case-row-header">
                                        <b>Name</b>
                                    </Col>
                                    <Col span={8}>
                                        {this.state.validation_check_flag ?
                                            <div className="errormessage">
                                                Case with this Validation ID already exists.
                                            </div> : null
                                        }
                                        <Input placeholder="Validation Study Name" value={this.state.newValidation}
                                               className={this.state.validation_check_flag ? "input-field-add-case errors-input" : "input-field-add-case"}
                                               onChange={this.changeValidationName}
                                        />
                                    </Col>
                                </Row>
                                <br></br>
                                <Row className="add-case-row">
                                    <Col span={5} className="add-case-row-header">
                                        <b>Description</b>
                                    </Col>
                                    <Col span={19}>
                                        <TextArea rows={4} onChange={this.changeDescription}
                                                  value={this.state.description}>

                                        </TextArea>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginAlerts.loginStatus,
        allCases: state.casesReducer,
        allCaseStatus: state.caseStatusReducer.case_status,
        allUsers: state.caseStatusReducer.users,
        numPages: state.caseStatusReducer.numPages,
        pageNumber: state.caseStatusReducer.pageNumber,
        total: state.caseStatusReducer.total,
        urlState: state.searchCaseReducer,
        isFetching: state.searchCaseReducer.isFetching
    };
};

export default connect(mapStateToProps)(validationStudies);
